import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';
import type { FC } from 'react';

export enum TextFieldType {
    Email = 'email',
    Text = 'text',
}

interface TextFieldProps {
    id: string;
    className?: string;
    type: TextFieldType;
    value: string;
    placeholder?: string;
    onChange?: (value: string) => void;
    required?: boolean;
    hasError?: boolean;
    errorMessage?: string;
    maxLength?: number;
}

export const TextField: FC<TextFieldProps> = ({
    id,
    className,
    type,
    value,
    placeholder,
    required,
    onChange,
    hasError,
    maxLength,
    errorMessage,
}) => {
    return (
        <div className={`flex flex-col gap-2 ${className}`}>
            <input
                maxLength={maxLength}
                id={id}
                type={type}
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                className={`${hasError ? 'border-red-50 border-2 border-solid' : 'border-none outline-none'} rounded-md bg-gray-100 w-full px-3 py-2.5 text-white text-sm ${required ? 'required' : ''} ${className ? className : ''}`}
                placeholder={placeholder}
            />
            {hasError && (
                <p className="flex flex-row gap-2 text-red-50 text-xs font-normal items-center">
                    <ExclamationCircleIcon className="w-5 h-5" />
                    {errorMessage}
                </p>
            )}
        </div>
    );
};
